module.exports = __webpack_public_path__ + "static/Alcatel_Lucent_Logo-863ac95764754e68f21dd2faa3388aab.svg";